import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ChakraProvider } from "@chakra-ui/react";
import { system } from "@/theme/system";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ChakraProvider value={system}>
        <App />
      </ChakraProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);

// PWA: register the static-shell service worker + surface update prompts.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    // Ask the browser to protect CacheStorage + IndexedDB (shell, drafts,
    // outbox) from storage-pressure eviction on field devices.
    if (navigator.storage && navigator.storage.persist) navigator.storage.persist().catch(() => {});
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        const notify = () => window.dispatchEvent(new CustomEvent("sw-update-available", { detail: reg }));
        if (reg.waiting && navigator.serviceWorker.controller) notify();
        reg.addEventListener("updatefound", () => {
          const worker = reg.installing;
          if (!worker) return;
          worker.addEventListener("statechange", () => {
            if (worker.state === "installed" && navigator.serviceWorker.controller) notify();
          });
        });
        // Long-lived PWAs are never "reloaded", so the browser's on-navigation
        // update check never runs — poll for new versions while the app is open
        // and whenever it returns to the foreground.
        const check = () => { if (navigator.onLine) reg.update().catch(() => {}); };
        setInterval(check, 30 * 60 * 1000);
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible") check();
        });
      })
      .catch(() => {});
    let reloaded = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (!reloaded) { reloaded = true; window.location.reload(); }
    });
  });
}
